export default __webpack_public_path__ + "static/media/about-me-desktop.bd28b6da.png";